import { Box } from '@mui/material';

const rule = {
  field: 'rule',
  headerName: 'Rule',
  flex: 0.8,
  type: 'customSelect',
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
};

const type = {
  field: 'ruleType',
  headerName: 'Type',
  flex: 0.8,
  type: 'customSelect',
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
};
const value = {
  field: 'values',
  headerName: 'Value',
  flex: 0.8,
  type: 'customSelect',
  customFilterOperators: ['hasAnyOf', 'containsAnySubstring'],
  getFilterValues: (row) => row.values?.map((v) => v.value),
  valueGetter: (params) => params.row.values?.map((v) => v.value).join(', ') ?? '',
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        overflowWrap: 'break-word',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: '4.5em',
        lineHeight: '1.5em',
      }}
    >
      {params.value}
    </Box>
  ),
};

const SITE_RULES = [rule, type, value];

export { SITE_RULES };
